import React, { useCallback, useEffect, useState } from 'react'
import './style.scss'
import axios from 'axios'
import { Icon } from 'react-icons-kit'
import { toast } from 'react-toastify'
import { api } from '../../../utils/api'
import { formatDateWithAMPM } from '../../../utils/helpers'
import 'react-toastify/dist/ReactToastify.css'
import { Images } from '../../../utils/Images'
import { NavLink, useParams } from 'react-router-dom'
import { phone, mail } from 'react-icons-kit/feather'
import { Routes, Route } from 'react-router-dom'

import AboutPage from './user/about/Index'
import GalleryPage from './user/gallery/Index'
import ConnectionPage from './user/connection/Index'
import ProposalSendPage from './user/proposalsend/Index'
import FavouritePage from './user/favouriteList/Index'
import BlockPage from './user/blockList/Index'
import PaymentlogPage from './Payment'
import RecentViewPage from './user/recentlyView/Index'
import ReportedProfilesPage from './user/reportedProfiles/Index'
import TimelinePage from './user/timeline/Index'
import MessagePage from './user/message/Index'
import GhostProfile from '../../../components/ghostLoader/user/profileLoader/Index'

//toast.configure({ autoClose: 2000 })
const Show = () => {
    const { id } = useParams()
    const [isloading, setLoading] = useState(true)
    const [user, setUser] = useState(null)
    const [header] = useState({
        headers: { Authorization: "Bearer " + localStorage.getItem("token") }
    })

    // get user
    const getUser = useCallback(async () => {
        try {
            const response = await axios.get(`${api}user/show/${id}`, header)
            if (response.status === 200) {
                setUser(response.data.user)
                setLoading(false)
            }
        } catch (error) {
            if (error) {
                toast.error(error.response.data.message)
            }
        }
    }, [id, header])

    useEffect(() => {
        getUser()
    }, [id, header, getUser])


    if (isloading) return (<GhostProfile />)

    return (
        <div className="dashboard-users-show pb-4">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 col-padding pb-0">
                        {/* Header container */}
                        <div className="card border-0 header-card">

                            {/* Header background */}
                            <div
                                className="image-container"
                                style={{
                                    backgroundImage: `url(${(user?.profilePicture?.clearImage ? `${process.env.REACT_APP_IMAGE_URL}/${user?.profilePicture?.clearImage}` : Images.Avatar)})`,
                                    backgroundSize: 'cover',
                                    backgroundRepeat: 'no-repeat',
                                    backgroundPosition: 'center center'
                                }}
                            ></div>

                            <div className="image rounded-circle">
                                <img src={user?.profilePicture?.clearImage ? `${process.env.REACT_APP_IMAGE_URL}/${user?.profilePicture?.clearImage}` : Images.Avatar} className="img-fluid" alt="..." />
                            </div>

                            <div className="card-body p-0 p-sm-4">
                                <div className="d-lg-flex">
                                    {/* Account information */}
                                    <div className="content-container shadow-sm flex-fill mt-4 mt-lg-0 ml-lg-4">
                                        <h5>{user?.name}</h5>
                                        <p>{user?.profileId}</p>
                                        <hr />
                                        <ul>
                                            <li>
                                                <h6>Account type<span>({user?.profileType})</span></h6>
                                            </li>
                                            <li>
                                                <h6>Account verified<span style={{ color: user?.isVerified ? "green" : "red" }}>
                                                    ({user?.isVerified ? 'Yes' : 'No'})</span>
                                                </h6>
                                            </li>
                                            <li>
                                                <h6>Profile locked<span style={{ color: user?.isLocked ? "red" : "green" }}>({user?.isLocked ? 'Yes' : 'No'})</span>
                                                </h6>
                                            </li>
                                            <li>
                                                <h6>Last loggedin<span style={{ color: user?.loggedinAt ? "green" : "red" }}>({formatDateWithAMPM(user?.loggedinAt)})</span>
                                                </h6>
                                            </li>
                                        </ul>
                                    </div>

                                    {/* User information */}
                                    <div className="content-container shadow-sm flex-fill mt-4 mt-lg-0 ml-lg-4">
                                        <p><Icon icon={phone} size={20} className="mr-2 mb-2" />{user?.phone}</p>
                                        <p className="text-lowercase"><Icon icon={mail} size={20} className="mr-2 mb-2" />{user?.email}</p>
                                        <hr />
                                        <ul>
                                            <li>
                                                <h6>Gender<span>({user?.gender})</span></h6>
                                            </li>
                                            <li>
                                                <h6>Looking For<span>({user?.lookingFor})</span></h6>
                                            </li>
                                            <li>
                                                <h6>Religion<span>({user?.religion})</span></h6>
                                                <p></p>
                                            </li>
                                            <li>
                                                <h6>Profession<span>({user?.professionArea})</span></h6>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Page Links */}
                        <div className="card border-0 shadow-sm page-links-container my-4 mt-sm-0">
                            <div className="card-body py-2">
                                <div className="btn-group">
                                    <NavLink to={`/dashboard/user/${id}/edit`} className={({ isActive }) => isActive ? "btn shadow-none border-right is-Active" : "btn shadow-none border-right"}>Edit</NavLink>
                                    <NavLink end to={`/dashboard/user/${id}/show/`} className={({ isActive }) => isActive ? "btn shadow-none border-right is-Active" : "btn shadow-none border-right"}>About</NavLink>
                                    <NavLink to={`/dashboard/user/${id}/show/gallery`} className={({ isActive }) => isActive ? "btn shadow-none border-right is-Active" : "btn shadow-none border-right"}>Gallery</NavLink>
                                    <NavLink to={`/dashboard/user/${id}/show/connections`} className={({ isActive }) => isActive ? "btn shadow-none border-right is-Active" : "btn shadow-none border-right"}>Connections</NavLink>
                                    <NavLink to={`/dashboard/user/${id}/show/proposalsend`} className={({ isActive }) => isActive ? "btn shadow-none border-right is-Active" : "btn shadow-none border-right"}>Proposal Send</NavLink>
                                    <NavLink to={`/dashboard/user/${id}/show/favourite-list`} className={({ isActive }) => isActive ? "btn shadow-none border-right is-Active" : "btn shadow-none border-right"}>Favourite List</NavLink>
                                    <NavLink to={`/dashboard/user/${id}/show/block-list`} className={({ isActive }) => isActive ? "btn shadow-none border-right is-Active" : "btn shadow-none border-right"}>Block List</NavLink>
                                    <NavLink to={`/dashboard/user/${id}/show/recently-view`} className={({ isActive }) => isActive ? "btn shadow-none border-right is-Active" : "btn shadow-none border-right"}>Recently View</NavLink>
                                    <NavLink to={`/dashboard/user/${id}/show/reported-profiles`} className={({ isActive }) => isActive ? "btn shadow-none border-right is-Active" : "btn shadow-none border-right"}>Reported Profiles</NavLink>
                                    <NavLink to={`/dashboard/user/${id}/show/timeline`} className={({ isActive }) => isActive ? "btn shadow-none border-right is-Active" : "btn shadow-none border-right"}>Timeline</NavLink>
                                    <NavLink to={`/dashboard/user/${id}/show/payment-log`} className={({ isActive }) => isActive ? "btn shadow-none border-right is-Active" : "btn shadow-none border-right"}>Payment Log</NavLink>
                                    <NavLink to={`/dashboard/user/${id}/show/admin-messages`} className={({ isActive }) => isActive ? "btn shadow-none is-Active" : "btn shadow-none"}>Admin Messages</NavLink>
                                </div></div>
                        </div>

                        {/* Main */}
                        <div>
                            <Routes>
                                <Route index element={<AboutPage user={user} />} />          {/* default page */}
                                <Route path="gallery" element={<GalleryPage user={user} />} />
                                <Route path="connections" element={<ConnectionPage user={user} />} />
                                <Route path="proposalsend" element={<ProposalSendPage user={user} />} />
                                <Route path="favourite-list" element={<FavouritePage user={user} />} />
                                <Route path="block-list" element={<BlockPage user={user} />} />
                                <Route path="recently-view" element={<RecentViewPage user={user} />} />
                                <Route path="reported-profiles" element={<ReportedProfilesPage user={user} />} />
                                <Route path="timeline" element={<TimelinePage user={user} />} />
                                <Route path="payment-log" element={<PaymentlogPage user={user} />} />
                                <Route path="admin-messages" element={<MessagePage user={user} />} />
                                <Route path="*" element={<h5>404</h5>} />
                            </Routes>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Show;